import { useSelector } from 'react-redux';

import { selectors } from '../store/dux/permissions-dux';

export function usePermissions() {
  return useSelector(selectors.all);
}
